import { render, staticRenderFns } from "./ConsumerContentBlock.vue?vue&type=template&id=3877e830"
import script from "./ConsumerContentBlock.vue?vue&type=script&lang=js"
export * from "./ConsumerContentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports